import {Typography} from '@sollapay/ui/components';

import type {FC, ReactNode} from 'react';

export interface CreatePayoutStepLayoutProps {
  title: string;
  subtitle: ReactNode;
  children: ReactNode;
}

/** Shared title/subtitle header + step padding, reused by every CreatePayoutFlow step. */
export const CreatePayoutStepLayout: FC<CreatePayoutStepLayoutProps> = ({
  title,
  subtitle,
  children
}) => (
  <div className="flex flex-col gap-6 py-6">
    <div className="flex flex-col items-start gap-1.5 text-start">
      <Typography size="display-xs" weight="semibold">
        {title}
      </Typography>
      <Typography size="sm" color="secondary" className="whitespace-normal">
        {subtitle}
      </Typography>
    </div>
    {children}
  </div>
);
